import { connect } from 'react-redux';
import SlideNavigation from '../components/SlideNavigation.jsx';
import { track } from '../actions/mixpanel';
import { openFullscreenDialog } from '../actions/ui';
import { firstSlide, lastSlide, nextSlide, previousSlide, togglePauseSlideRotation } from '../actions/slides';
import { getCurrentDeck, getDeckIndex } from '../selectors';

const mapStateToProps = (state, props) => {
  const deck = getCurrentDeck(state);

  if (Object.keys(deck).length === 0) {
    return {};
  }

  const currentSlide = state.slides.byId[deck.slide_order[props.slideIndex]] || {};

  return {
    slideName: currentSlide.name,
    deckCount: state.decks.order.length,
    deckIndex: getDeckIndex(state),
    slideCounts: state.decks.order.map(deckId => {
      const deck = state.decks.byId[deckId];
      return deck ? deck.slide_order.length : 0;
    })
  };
};

const mapDispatchToProps = {
  firstSlide,
  lastSlide,
  nextSlide,
  previousSlide,
  openFullscreenDialog,
  togglePauseSlideRotation,
  track,
};

export default connect(mapStateToProps, mapDispatchToProps)(SlideNavigation);
